import { all, put, select } from 'redux-saga/effects';
import { getCurrentUser, getPurchaseUserId, isRegisteredUser } from 'redux/query';
import { transferSubscriptionApiRequest } from 'api/balloon';
import { clearPayerUserId, getUserPaymentInfosRequest, successTransferUserSubscriptions } from 'redux/actions';
import Cookies from 'js-cookie';

export function* migrateSubscriptionSaga() {
  const state = yield select();

  const now = new Date().getTime();

  const payerUserId = getPurchaseUserId(state);
  const user = getCurrentUser(state);
  const isRegistered = isRegisteredUser(state);

  Cookies.set('user_session', now, { path: '/' });

  if (payerUserId && isRegistered && user.id !== payerUserId) {
    yield transferSubscriptionApiRequest({ guestUserId: payerUserId });
    yield all([put(clearPayerUserId()), put(successTransferUserSubscriptions())]);
  }
  yield put(getUserPaymentInfosRequest({ renewable: false }));
}
